import { Injectable } from "@angular/core";
import { isSPSACompanyUser, ReportOrdersTotal } from "../../core";
import { SheetjsService } from "../../shared";

@Injectable({
    providedIn: 'root'
})
export class ReportPickingService {
    /**
     * Creates an instance of report picking service.
     * @param sheetjsService SheetjsService
     */
    constructor(private sheetjsService: SheetjsService) { }
    /**
     * Exports to withdraw
     * @param data any[]
     */
    exportToWithdraw(data: any[]) {
        this.sheetjsService.exportAsExcelFile(
            data.map((x:any) => {
                return {
                    'NRO. LPN': x.lpn,
                    'NV': x.orderNumber,
                    'UBICACIÓN DE LPN': x.location,
                    'FECHA Y HORA DE CANCELACIÓN DEL PEDIDO': x.canceledAt,
                    'ESTADO NV': x.stateOrderDispatchDescription,
                    'ÁREA': x.area,
                    'SKU': x.sku,
                    'DESCRIPCIÓN': x.description,
                    'CANT.': x.cant,
                    'FECHA Y HORA DE INICIO DE REINGRESO': x.reEntryStartDate,
                    'FECHA Y HORA DE FIN DE REINGRESO': x.endDateOfReEntry,
                    'TIPO DE DESPACHO': x.dispatchTypeCode
                }
            }),
            'Reporte de cancelados por retirar'
        );
    }
    /**
     * Exports orders picking
     * @param data any[]
     */
    exportOrdersPickingAll(data: any[]) {
       const containerDateCreatedColumnName = isSPSACompanyUser()? 'FECHA Y HORA ALMACENADO JABA':'FECHA Y HORA DE CREACION LPN';
        this.sheetjsService.exportAsExcelFile(
            data.map((x:ReportOrdersTotal) => {
                 return {
                    'SKU': x.sku,
                    'DESCRIPCIÓN': x.description ? (x.description).replace('�', '') : '',
                    'MARCA': x.tradeMark,
                    'ESTADO': x.stateOrderName,
                    'NUMERO DE NOTA DE VENTA': x.orderNumber,
                    'LPN': x.containerSerialNumber,
                    'CANTIDAD SOLICITADA': x.sAmountRequested,
                    'CANTIDAD ATENDIDA': x.sAmountAttended,
                    'CANTIDAD CONSOLIDADA': x.sAmountConsolidated,
                    'CANTIDAD CANCELADA': x.sAmountCancelled,
                    'DIVISIÓN': x.division,
                    'ÁREA': x.area,
                    'DEPARTAMENTO': x.department,
                    'ENTIDAD DE PICKING': x.entityId,
                    'FECHA Y HORA DE CREACIÓN': x.dateCreated,
                    'UBICACIÓN': x.location,
                    'FECHA DE DESPACHO': x.dateDispatch,
                    'FECHA Y HORA DE INICIO DE PICKING': x.lotDateCreated,
                    'FECHA Y HORA DE FIN DE PICKING': x.lotFinishedAt,
                    'FECHA Y HORA DE INICIO DE PACKING': x.dateConsolidatedInitial,
                    [containerDateCreatedColumnName]: x.containerDateCreated,
                    'FECHA Y HORA DE UBICACIÓN LPN/JABA': x.labelDateCreated,
                    'FECHA Y HORA DE CONSOLIDACIÓN': x.dateConsolidated,
                    'FECHA Y HORA DE FACTURACIÓN': x.confirmationDate,
                    'TIPO DE ENTREGA': x.methodDelivery,
                    'ESTADO DE DESPACHO': x.stateOrderDispatchName,
                    'USUARIO PICKING': x.userPicking,
                    'USUARIO PRIMER PICKING': x.firstPicker,
                    'USUARIO FINAL PICKING': x.finalPicker,
                    'USUARIO ULTIMO PICKING': x.userLastPicking,
                    'USUARIO CONSOLIDACIÓN': x.userConsolidated,
                    'USUARIO PRIMERA UBICACIÓN': x.pickerLocation,
                    'USUARIO ULTIMA UBICACIÓN': x.lastLocationPicker,
                    'FECHA Y HORA DE IMPRESIÓN DE ETIQUETA FINAL': x.lastUpdated,
                    'FECHA DE CONFIRMACIÓN DEL CLIENTE': x.confirmationDate,
                    'FECHA Y HORA DE CANCELACIÓN': x.canceledAt,
                    'DESTINO FINAL': this.route(x.destinationRoute),
                    'MOTIVO DE FALTANTE INICIAL': x.incompleteConcat,
                    'MOTIVO DE FALTANTE FINAL': x.incompletePrecancel,
                    'FECHA Y HORA DE INICIO DE REINGRESO': x.reEntryStartDate,
                    'FECHA Y HORA DE FIN DE REINGRESO': x.endDateOfReEntry,
                    'NUMERO DE DESPACHO': x.serialNumber,
                    'ECOMMERCE ID': x.ecommerceId,
                    'PICKING CRUZADO': x.pickingCrossed,
                    'SUCURSAL CRUZADA / ESTADO DE DESPACHO': x.entityCrossed,
                    'TIPO DE DESPACHO': x.dispatchTypeCode,
                    'METODO DEL PAGO': x.paymentMethodName,
                    'ESTADO DEL PAGO (Respuesta del EMAP)': x.pendingPayment,
                    'USUARIO(S) PRECANCELACION': x.precancelledUsername,
                    'USUARIO(S) CANCELACION'   : x.cancelledUsername,
                    'FECHA MAXIMA DE CARGA': x.pickingDate,
                    'FECHA DE DESPACHO ORIGINAL': x.deliveryDate,
                    'CANAL DE VENTA': x.saleChannel,
                    'FECHA Y HORA DE CREACION DE DESPACHO': x.dispatchCreatedAt
                    // 'ESTADO DEL PAGO (Respuesta del EMAP)': x.pendingPayment ? 'PENDIENTE' : 'PAGADO'
                };
            }),
            'Reporte de pedidos'
        );
    }
    /**
     * Exports orders picking
     * @param data any[]
     */
    exportOrdersPicking(data: any[]) {
        this.sheetjsService.exportAsExcelFile(
            data.map(x => {
                return {
                    SKU: x.sku,
                    'DESCRIPCIÓN': x.description ? (x.description).replace('�', '') : '',
                    'MARCA': x.tradeMark,
                    ESTADO: x.stateOrderName,
                    'NUMERO DE NOTA DE VENTA': x.orderNumber,
                    LPN: x.containerSerialNumber,
                    'CANTIDAD SOLICITADA': x.amountRequested,
                    'CANTIDAD ATENDIDA': x.amountAttended,
                    'CANTIDAD CONSOLIDADA': x.amountConsolidated,
                    'CANTIDAD CANCELADA': x.amountCancelled,
                    'DIVISIÓN': x.department,
                    'ÁREA': x.area,
                    DEPARTAMENTO: x.division,
                    'ENTIDAD DE PICKING': x.entityId,
                    'FECHA Y HORA DE CREACIÓN': x.dateCreated,
                    'UBICACIÓN': x.location,
                    'FECHA DE DESPACHO': x.dateDispatch,
                    'FECHA Y HORA DE INICIO DE PICKING': x.loteDateCreated,
                    'FECHA Y HORA DE FIN DE PICKING': x.loteFinishedAt,
                    'FECHA Y HORA DE INICIO DE PACKING': x.containerDateCreated,
                    'FECHA Y HORA DE ETIQUETADO': x.containerDateCreated,
                    'FECHA Y HORA DE PRIMERA UBICACIÓN': x.labelDateCreated,
                    'FECHA Y HORA DE CONSOLIDACIÓN': x.dateConsolidated,
                    'FECHA Y HORA DE FACTURACIÓN': x.confirmationDate,
                    'TIPO DE ENTREGA': x.methodDelivery,
                    'ESTADO DE DESPACHO': x.stateOrderDispatchName,
                    'USUARIO PICKING': x.userPicking,
                    'USUARIO ULTIMO PICKING': x.userLastPicking,
                    'USUARIO CONSOLIDACIÓN': x.userConsolidated,
                    'USUARIO PRIMERA UBICACIÓN': x.pickerLocation,
                    'USUARIO ULTIMA UBICACIÓN': x.lastLocationPicker,
                    'FECHA Y HORA DE IMPRESIÓN DE ETIQUETA FINAL': x.lastUpdated,
                    'FECHA DE CONFIRMACIÓN DEL CLIENTE': x.confirmationDate,
                    'FECHA Y HORA DE CANCELACIÓN': x.canceledAt,
                    'DESTINO FINAL': this.route(x.destinationRoute),
                    'MOTIVO DE FALTANTE INICIAL': x.incompleteConcat,
                    'MOTIVO DE FALTANTE FINAL': x.incompletePrecancel,
                    'FECHA Y HORA DE INICIO DE REINGRESO': x.reEntryStartDate,
                    'FECHA Y HORA DE FIN DE REINGRESO': x.endDateOfReEntry,
                    'NUMERO DE DESPACHO': x.serialNumber,
                    'ECOMMERCE ID': x.ecommerceId,
                    'TIPO DE DESPACHO': x.dispatchTypeCode
                };
            }),
            'Reporte de pedidos'
        );
    }
    /**
     * Routes report picking service
     * @param originRoute string
     * @returns string
     */
    private route(originRoute: string) {
        if (originRoute) {
            const entitiesRoutes = originRoute.split('-');
            return entitiesRoutes[entitiesRoutes.length - 1];
        }
        return "";
    }
}
